import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ReportResponse, ReportMenuCategory } from '../core/models/report.models';

@Injectable({
  providedIn: 'root',
})
export class ReportMenuService {
  // Base URL for all report-related endpoints from the environment file.
  private reportsApiUrl = `${environment.reportApiBaseUrl}/Reports`;

  constructor(private http: HttpClient) {}

  getReportMenuItems(): Observable<ReportMenuCategory[]> {
    // Making a live API call to fetch dynamic report menu items from a specific endpoint.
    return this.http.get<ReportMenuCategory[]>(`${this.reportsApiUrl}/menu`);
  }

  getReportData(reportId: number, payload: any): Observable<ReportResponse> {
    // Fetches the data for a specific report by its ID using a POST request.
    return this.http.post<ReportResponse>(`${this.reportsApiUrl}/${reportId}`, payload);
  }
}